import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const routeTitles = {
  "/app/dashboard": "Bảng điều khiển",
  "/app/category/all-category": "Danh mục sản phẩm",
  "/app/category/edit-category": "Chỉnh sửa danh mục",
  "/app/product/all-product": "Danh sách sản phẩm",
  "/app/product/edit-product": "Chỉnh sửa sản phẩm",
  "/app/order/all-orders": "Danh sách phiếu xuất kho",
  "/app/order/edit-order": "Chỉnh sửa đơn hàng",
  "/app/customer/all-customer": "Danh sách khách hàng",
  "/app/customer/edit-customer": "Chỉnh sửa khách hàng",
  "/app/branch/all-branch": "Danh sách chi nhánh",
  "/app/branch/edit-branch": "Chỉnh sửa chi nhánh",
  "/app/purchase/add-purchase": "Lập phiếu nhập kho",
  "/app/purchase/all-purchase": "Danh sách phiếu nhập kho",
  "/app/supplier/all-supplier": "Danh sách nhà cung cấp",
  "/app/supplier/edit-supplier": "Chỉnh sửa nhà cung cấp",
  "/app/user/all-user": "Danh sách nhân viên",
  "/app/user/edit-user": "Chỉnh sửa nhân viên",
  "/app/menus/all-menu": "Danh sách menu",
  "/app/menus/edit-menu": "Chỉnh sửa menu",
  "/app/map": "Bản đồ khu vực",
  "/app/shipping/tracking": "Theo dõi giao hàng",
  "/app/profile": "Thông tin cá nhân",
  "/app/settings": "Cấu hình hệ thống",
  "/app/permission/all-permission": "Phân quyền người dùng",
  "/app/permission/add-permission": "Thêm phân quyền",
  "/app/permission/edit-permission": "Chỉnh sửa phân quyền",
  "/app/pos": "Bán hàng (POS)",
  "/app/inventory-check/list": "Danh sách phiếu kiểm kho",
  "/app/inventory-check/entry": "Kiểm kho chi tiết",
  "/app/pos-invoice/all": "Danh sách hóa đơn bán hàng POS",
  "/app/purchase-return/all": "Trả hàng nhập",
  "/app/purchase-return/add": "Lập phiếu trả hàng nhập",
  "/app/sales-return/all": "Trả hàng bán",
  "/app/sales-return/add": "Lập phiếu nhận hàng trả",
  "/app/debt/supplier": "Công nợ nhà cung cấp",
  "/app/debt/customer": "Công nợ khách hàng",
  "/app/cash-book": "Sổ quỹ thu chi",
  "/login": "Đăng nhập",
  "/forgot-password": "Quên mật khẩu",
  "/shipping/login": "Shipper đăng nhập",
  "/shipping/tracking": "Shipper theo dõi đơn hàng",
  "/403": "Không có quyền truy cập",
  "/404": "Không tìm thấy trang"
};

const getTitleFromPathname = (pathname) => {
  const keys = Object.keys(routeTitles).sort((a, b) => b.length - a.length);
  for (const key of keys) {
    if (pathname === key || pathname.startsWith(key + "/")) {
      return `${routeTitles[key]}`;
    }
  }
  return "Hệ thống quản lý kho";
};

function AccessibleNavigationAnnouncer() {
  const [message, setMessage] = useState('')
  const location = useLocation()

  useEffect(() => {
    // Cập nhật tiêu đề tab trình duyệt
    document.title = getTitleFromPathname(location.pathname);

    // ignore the /
    if (location.pathname.slice(1)) {
      // make sure navigation has occurred and screen reader is ready
      setTimeout(() => setMessage(`Navigated to ${location.pathname.slice(1)} page.`), 500)
    } else {
      setMessage('')
    }
  }, [location])

  return (
    <span className="sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </span>
  )
}

export default AccessibleNavigationAnnouncer
